import { clampSceneValueV1 } from "./sceneRulesV1";

export const SCENE_RULE_VERSION_V2 = 2 as const;
export const SCENE_V2_MIN_SLIME_SCALE = 0.5;
export const SCENE_V2_MAX_SLIME_SCALE = 2.05;

/**
 * V2 widens the continuous money-to-size curve while preserving the
 * one-farm-unit anchor at exactly 1.0.
 */
export function slimeScaleSignalV2(amountRatio: number): number {
  const safeRatio =
    Number.isFinite(amountRatio) && amountRatio > 0 ? amountRatio : 0;
  const rawScale = 0.5 + 0.5 * Math.log2(1 + safeRatio);
  return clampSceneValueV1(
    rawScale,
    SCENE_V2_MIN_SLIME_SCALE,
    SCENE_V2_MAX_SLIME_SCALE,
  );
}
